"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import isValidEmail from "@/lib/is-valid-email";
import { TUser } from "@/types/user";
import { Loader2 } from "lucide-react";
import { useState } from "react";

export default function User({
  onUserSave,
}: {
  onUserSave: (user: TUser) => void;
}) {
  const [selectedUser, setSelectedUser] = useState<TUser>({
    id: null,
    password: "",
    company: "",
    name: "",
    surname: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    nif: "",
    createdDate: new Date(),
  });

  const [userErrors, setUserErrors] = useState({
    name: false,
    surname: false,
    email: false,
    phone: false,
    password: false,
    repeatPassword: false,
  });

  const [repeatPassword, setRepeatPassword] = useState("");
  const [isLoading, setIsloading] = useState(false);

  return (
    <div>
      <div className="w-full flex flex-col md:flex-row gap-4 md:gap-8">
        <div className="flex-1">
          <Label
            className={
              "z-10 pl-1 relative transition-opacity duration-500 text-md -mb-1 " +
              (selectedUser?.name === "" && userErrors.name
                ? " text-secondary-text"
                : "")
            }
            htmlFor="name"
          >
            Nombre*
          </Label>
          <Input
            className="pl-1"
            name="name"
            defaultValue={selectedUser?.name}
            onChange={(e) =>
              setSelectedUser({ ...selectedUser, name: e.target.value })
            }
            onBlur={() =>
              setUserErrors({ ...userErrors, name: selectedUser.name === "" })
            }
          />
          <div
            className={
              "mt-2 text-xs text-secondary-text transition-opacity duration-500 " +
              (selectedUser?.name === "" && userErrors.name
                ? "opacity-100"
                : "opacity-0")
            }
          >
            Por favor, introduzca los datos correctamente para este campo
            (obligatorio).
          </div>
        </div>
        <div className="flex-1">
          <Label
            className={
              "z-10 pl-1 relative transition-opacity duration-500 text-md text-md -mb-1 " +
              (selectedUser?.surname === "" && userErrors.surname
                ? " text-secondary-text"
                : "")
            }
            htmlFor="surname"
          >
            Apellidos*
          </Label>
          <Input
            className="pl-1"
            name="surname"
            defaultValue={selectedUser?.surname}
            onChange={(e) =>
              setSelectedUser({ ...selectedUser, surname: e.target.value })
            }
            onBlur={() =>
              setUserErrors({
                ...userErrors,
                surname: selectedUser.surname === "",
              })
            }
          />
          <div
            className={
              "mt-2 text-xs text-secondary-text transition-opacity duration-500 " +
              (selectedUser?.surname === "" && userErrors.surname
                ? "opacity-100"
                : "opacity-0")
            }
          >
            Por favor, introduzca los datos correctamente para este campo
            (obligatorio).
          </div>
        </div>
      </div>

      <div className="w-full mt-4 flex gap-4 md:gap-8 flex-col md:flex-row">
        <div className="flex-1">
          <Label
            className={
              "z-10 pl-1 relative transition-opacity duration-500 text-md -mb-1 " +
              (selectedUser?.phone === "" && userErrors.phone
                ? " text-secondary-text"
                : "")
            }
            htmlFor="phone"
          >
            Teléfono*
          </Label>
          <Input
            name="phone"
            className="pl-1"
            defaultValue={selectedUser?.phone}
            onChange={(e) =>
              setSelectedUser({ ...selectedUser, phone: e.target.value })
            }
            onBlur={() =>
              setUserErrors({
                ...userErrors,
                phone: selectedUser.phone === "",
              })
            }
          />
          <div
            className={
              "mt-2 text-xs text-secondary-text transition-opacity duration-500 " +
              (selectedUser?.phone === "" && userErrors.phone
                ? "opacity-100"
                : "opacity-0")
            }
          >
            Por favor, introduzca los datos correctamente para este campo
            (obligatorio).
          </div>
        </div>
        <div className="flex-1">
          <Label
            className={
              "z-10 pl-1 relative transition-opacity duration-500 text-md -mb-1 " +
              ((selectedUser?.email === "" ||
                !isValidEmail(selectedUser.email)) &&
              userErrors.email
                ? " text-secondary-text"
                : "")
            }
            htmlFor="email"
          >
            Dirección de correo electrónico*
          </Label>
          <Input
            className="pl-1"
            name="email"
            defaultValue={selectedUser?.email}
            onChange={(e) => {
              setSelectedUser({ ...selectedUser, email: e.target.value });
              setUserErrors({
                ...userErrors,
                email: e.target.value === "" || !isValidEmail(e.target.value),
              });
            }}
            onBlur={() =>
              setUserErrors({
                ...userErrors,
                email:
                  selectedUser.email === "" ||
                  !isValidEmail(selectedUser.email),
              })
            }
          />
          <div
            className={
              "mt-2 text-xs text-secondary-text transition-opacity duration-500 " +
              ((selectedUser?.email === "" ||
                !isValidEmail(selectedUser.email)) &&
              userErrors.email
                ? "opacity-100"
                : "opacity-0")
            }
          >
            Por favor, introduzca los datos correctamente para este campo
            (obligatorio).
          </div>
        </div>
      </div>

      <div className="w-full mt-4 flex flex-col md:flex-row gap-4 md:gap-8">
        <div className="flex-1">
          <Label
            className={
              "z-10 pl-1 relative transition-opacity duration-500 text-md -mb-1 " +
              ((selectedUser?.password === "" ||
                (selectedUser?.password || "").length < 8) &&
              userErrors.password
                ? " text-secondary-text"
                : "")
            }
            htmlFor="password"
          >
            Contraseña (Debe tener al menos 8 caracteres.)*
          </Label>
          <Input
            className="pl-1"
            name="password"
            type="password"
            defaultValue={selectedUser?.password || ""}
            onChange={(e) =>
              setSelectedUser({ ...selectedUser, password: e.target.value })
            }
            onBlur={() =>
              setUserErrors({
                ...userErrors,
                password:
                  selectedUser.password === "" ||
                  (selectedUser?.password || "").length < 8,
              })
            }
          />
          <div
            className={
              "mt-2 text-xs text-secondary-text transition-opacity duration-500 " +
              ((selectedUser?.password === "" ||
                (selectedUser?.password || "").length < 8) &&
              userErrors.password
                ? "opacity-100"
                : "opacity-0")
            }
          >
            Por favor, introduzca los datos correctamente para este campo
            (obligatorio).
          </div>
        </div>
        <div className="flex-1">
          <Label
            className={
              "z-10 pl-1 relative transition-opacity duration-500 text-md text-md -mb-1 " +
              ((repeatPassword === "" ||
                repeatPassword !== selectedUser.password) &&
              userErrors.repeatPassword
                ? " text-secondary-text"
                : "")
            }
            htmlFor="repeatPassword"
          >
            Repetir contraseña*
          </Label>
          <Input
            className="pl-1"
            name="repeatPassword"
            type="password"
            defaultValue={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            onBlur={() =>
              setUserErrors({
                ...userErrors,
                repeatPassword:
                  repeatPassword === "" ||
                  repeatPassword !== selectedUser.password,
              })
            }
          />
          <div
            className={
              "mt-2 text-xs text-secondary-text transition-opacity duration-500 " +
              ((repeatPassword === "" ||
                selectedUser.password !== repeatPassword) &&
              userErrors.repeatPassword
                ? "opacity-100"
                : "opacity-0")
            }
          >
            Por favor, introduzca los datos correctamente para este campo y
            asegúrate de que las contraseñas sean las mismas..
          </div>
        </div>
      </div>
      <div className="flex justify-end w-full mt-14">
        <Button
          disabled={
            !selectedUser ||
            selectedUser.email === "" ||
            selectedUser.name === "" ||
            selectedUser.surname === "" ||
            selectedUser.phone === "" ||
            selectedUser.password === "" ||
            (selectedUser.password || "").length < 8 ||
            repeatPassword === "" ||
            selectedUser.password !== repeatPassword ||
            userErrors.email ||
            userErrors.name ||
            userErrors.phone ||
            userErrors.surname ||
            userErrors.password ||
            userErrors.repeatPassword
          }
          onClick={() => {
            onUserSave(selectedUser);
            setIsloading(true);

            setTimeout(() => {
              setIsloading(false);
            }, 1500);
          }}
        >
          {isLoading ? <Loader2 className="animate-spin" /> : <></>}
          Continuar
        </Button>
      </div>
    </div>
  );
}
